import React, { useEffect, useState } from "react";
import TopNav from "../layouts/TopNav";
import { AiOutlinePlusCircle } from "react-icons/ai";
import "../Styles/Product.css";
import { BsTrash } from "react-icons/bs";
import AddProduct from "../components/Modals/AddProduct";
import DeleteProduct from "../components/Modals/DeleteProduct";
import { toast, ToastContainer } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import { BsSearch, BsPencil } from "react-icons/bs";
import Swal from "sweetalert2";
import EditProduct from "../components/Modals/EditProduct";
import ReLoginModal from "../components/ReLoginModal";
import ConfirmDelete from "../components/Modals/ConfirmDelete";
import api from "../util/axios";

type Product = {
  name: string;
  description: string;
  unitOfMeasure: string;
  category: string;
  price: any;
  quantity: string;
  _id: string;
};

const Product = ({ isOpen }: any) => {
  const [proAddModal, setProAddModal] = useState(false);
  const [deleteModal, setDeletemodal] = useState(false);
  const [reLogin, setReLogin] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [opEdit, setOpEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [getProduct, setGetProduct] = useState<Product[]>([]);
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  const [saveProductId, setSaveProductId] = useState<string | null>(null);
  const [saveData, setSaveData] = useState<string | null>(null);
  const [sign, setSign] = useState({
    name: "",
    description: "",
    category: "oil and gas",
    unitOfMeasure: "Liters",
    quantity: "",
    cost: "",
    selling: "",
  });

  const handleAddPro = () => {
    setProAddModal(!proAddModal);
  };

  const handleDeleteCat = () => {
    setDeletemodal(!deleteModal);
  };

  const token = window.localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleChange = ({ target: { name, value } }: any) => {
    console.log(value);
    setSign((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };
  const datas = {
    name: sign.name,
    description: sign.description,
    category: sign.category,
    unitOfMeasure: sign.unitOfMeasure,
    quantity: sign.quantity,
    price: {
      // cost: sign.cost,
      selling: sign.selling,
    },
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    api
      .post("/inventory", datas, {
        headers: headers,
      })

      .then((res) => {
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        setProAddModal(false);
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  function queryCustomer() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api
      .get("/inventory", {
        headers: headers,
      })
      .then((res) => {
        const dataArray = Array.isArray(res.data.data)
          ? res.data.data
          : Object.values(res.data.data);
        setGetProduct(dataArray);

        if (res.data.message === "Inventory maximum limit reached") {
          Swal.fire({
            title: `Error!`,
            text: `${res.data.message}`,
            icon: "error",
            showCancelButton: false,
            confirmButtonColor: "red",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        Swal.fire({
          title: `Error!`,
          text: `${error.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
      });
  }

  useEffect(() => {
    queryCustomer();
  }, []);

  const handleSelectRow = (productId: string, productDetails: any) => {
    setSaveProductId(productId);
    setSaveData(productDetails);
    setSelectedRowId((prevSelectedRowId) =>
      prevSelectedRowId === productId ? null : productId
    );
  };

  const handleEdit = () => {
    if (selectedRowId === null) {
      toast.error("Please select a product to Edit");
      return;
    }
    setOpEdit(!opEdit);
  };

  const handleDeleteModal = () => {
    if (selectedRowId === null) {
      toast.error("Please select a product to delete");
      return;
    }
    setConfirmDelete(!confirmDelete);
  };

  const handleDelete = () => {
    api
      .delete(
        `/inventory/${saveProductId}`,
        {
          headers: headers,
        }
      )
      .then((res) => {
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        setProAddModal(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="board">
      <ToastContainer />
      <TopNav title="Product" />
      {reLogin ? <ReLoginModal /> : null}
      <div className="product">
        <div className="productBtn">
          <button onClick={handleAddPro} className="productBtn1">
            <AiOutlinePlusCircle />
            Add Product
          </button>
          <button onClick={handleDeleteModal} className="productBtn2">
            <BsTrash />
            Delete Product
          </button>

          <button
            onClick={handleEdit}
            className="productBtn1"
            style={{ backgroundColor: "#E9D502" }}
          >
            <BsPencil />
            Edit Product
          </button>
        </div>
        <div className="method">
          <div className="apInput">
            <input
              type="text"
              value={searchQuery}
              placeholder="search by name"
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <BsSearch className="apIcon" />
          </div>
        </div>

        <div className="proDuctTable">
          <table className="inTable">
            <tr className="heTable poHead">
              <th className="sn">S/N</th>
              <th>Action</th>
              <th>Product Name</th>
              <th>Description</th>
              <th>Unit Price</th>
              <th>Type/Categories</th>
              <th>Unit of Measurement</th>
              <th>Quantity</th>
            </tr>

            {getProduct
              ?.filter((product) =>
                product.name.toLowerCase().includes(searchQuery.toLowerCase())
              )
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((product, inx) => {
                const isSelected = product._id === selectedRowId;
                return (
                  <tr
                    key={inx}
                    className={isSelected ? "selectedRow" : "Tbody"}
                  >
                    <td className="sn">{inx + 1}</td>
                    <td>
                      <input
                        type="checkbox"
                        name="check"
                        checked={isSelected}
                        style={{ outline: "none" }}
                        onClick={() => handleSelectRow(product._id, product)}
                      />
                    </td>
                    <td>{product.name}</td>
                    <td>{product.description}</td>
                    <td>{product?.price?.selling} </td>
                    <td>{product.category}</td>
                    <td>{product.unitOfMeasure}</td>
                    <td>{product.quantity}</td>
                  </tr>
                );
              })}
          </table>
        </div>
      </div>

      {proAddModal ? (
        <AddProduct
          handleAddPro={handleAddPro}
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          sign={sign}
          loading={loading}
        />
      ) : null}
      {deleteModal ? <DeleteProduct handleDeleteCat={handleDeleteCat} /> : null}

      {opEdit ? (
        <EditProduct handleEdit={handleEdit} saveData={saveData} />
      ) : null}

      {confirmDelete ? (
        <ConfirmDelete
          saveData={saveData}
          handleDelete={handleDelete}
          handleDeleteModal={handleDeleteModal}
          setConfirmDelete={setConfirmDelete}
        />
      ) : null}

      <TablePagination
        rowsPerPageOptions={[15, 25, 50]}
        component="div"
        count={getProduct.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default Product;
